<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let email: string;

</script>

<style>
  .fizz-layout-one-col-centered {
    min-height: 100vh;
  }

</style>

<div class="fizz-layout-one-col-centered fizz-surface-gray">
  <div data-grid-area="header">
    <h1 class="fizz-heading-1 fizz-stack-32 fizz-text-center">
      <Icon
        className={"fizz-margin-auto"}
        type="ProviLogo"
        height="50"
        width="166"
        fill="#002B48"
      />
    </h1>
  </div>

  <div data-grid-area="main" class="fizz-stack-32">
    <form class="fizz-card fizz-inset-squish-96 fizz-flow-24 fizz-radius-medium fizz-elevation-1">
      <h2 class="fizz-heading-2 fizz-text-center fizz-stack-8">Password reset instructions sent</h2>
      <p class="fizz-text-center">
        If you have an account, an email has been sent to <strong>{email}</strong> with further instructions.
      </p>

      <p class="fizz-text-center fizz-text-small">
        <a href="/users/sign_in" on:click={() => (window.location.href = "/users/sign_in")}
          >Back to login</a
        >
      </p>
    </form>
  </div>
</div>
